// src/components/result/ScoreTable.js
import React from "react";
import ScoresRadar from "./ScoresRadar";

// 그래프/표에 쓸 순서
const ORDER = ["E", "I", "S", "N", "T", "F", "P", "J"];

// 라벨
const TRAIT_LABEL = {
  E: "(외향)",
  I: "(내향)",
  S: "(감각)",
  N: "(직관)",
  T: "(사고)",
  F: "(감정)",
  P: "(인식)",
  J: "(판단)",
};

// 점수 구간별 설명
const TRAIT_DESC_BY_LEVEL = {
  E: {
    high: "사람 많은 데 가야 오늘 뭘 한 것 같은 느낌이 든다.",
    mid: "사람 만나는 건 좋은데, 집콕도 꼭 필요하다.",
    low: "굳이 약속 안 잡아도 멀쩡히 잘 산다.",
  },
  I: {
    high: "혼자 있는 시간이 막히면 바로 멘탈 교통정체 온다.",
    mid: "사람도 좋고 혼자도 좋다, 비율만 잘 맞으면 된다.",
    low: "혼자 있는 시간이 길면 괜히 생각이 너무 많아진다.",
  },
  S: {
    high: "눈으로 보고 만져지는 것부터 확인해야 마음이 놓인다.",
    mid: "아이디어도 좋지만, 결국 현실이 어떻게 돌아가는지가 중요하다.",
    low: "지금보다 ‘나중에’ 머릿속 시뮬레이션을 더 자주 돌리는 편이다.",
  },
  N: {
    high: "일어나지도 않은 일을 머릿속에서 이미 세 번은 살아봤다.",
    mid: "가끔 쓸데없이 멀리까지 상상하지만, 현실도 꽤 잘 본다.",
    low: "지금 할 일부터 처리하느라, 먼 미래는 일단 뒤로 밀어둔다.",
  },
  T: {
    high: "위로보다 해결책부터 떠오르고, 말도 그렇게 나간다.",
    mid: "마음은 공감, 머리는 계산 둘 다 돌아가는 편이다.",
    low: "맞는 말이어도 너무 차갑게 들리면 일단 거부감부터 느낀다.",
  },
  F: {
    high: "분위기, 표정, 말투 다 잡음처럼 다 들어와 버린다.",
    mid: "논리도 중요한데, 말하는 사람 마음도 동시에 신경 쓴다.",
    low: "상대 기분은 신경 쓰지만, 너무 휘둘리지는 않으려 한다.",
  },
  P: {
    high: "일단 시작하고, 수습은 늘 미래의 나에게 맡겨진다.",
    mid: "계획은 세우지만, 상황 봐서 유연하게 갈아엎을 준비도 돼 있다.",
    low: "갑자기 바뀌는 일정보다, 미리 정해진 플랜이 마음이 편하다.",
  },
  J: {
    high: "시작도 전에 엑셀부터 열고, 마감일부터 박아둔다.",
    mid: "대충 언제까지 해야 할지는 정해두고 움직이는 편이다.",
    low: "계획표를 보면 답답하고, 손부터 움직이는 쪽이 편하다.",
  },
};

function getLevel(value) {
  if (value >= 70) return "high";
  if (value >= 40) return "mid";
  return "low";
}

function ScoreTable({ scores }) {
  // 디버그/디자인용 기본값
  const defaultScores = {
    E: 71,
    I: 78,
    S: 33,
    N: 88,
    T: 49,
    F: 81,
    P: 42,
    J: 86,
  };

  const data = scores || defaultScores;
  // 🔽 여기 추가: 점수 높은 순으로 trait 정렬
  const sortedTraits = ORDER.slice().sort((a, b) => {
    const va = data[a] ?? 0;
    const vb = data[b] ?? 0;
    return vb - va; // 내림차순
  });

  return (
    <section className="result-section">
      <h2 className="result-section-title">에너지 구성표</h2>

      <div className="result-score-card">
        {sortedTraits.map((trait) => {
          const value = data[trait] ?? 0;
          const level = getLevel(value);
          const desc =
            (TRAIT_DESC_BY_LEVEL[trait] && TRAIT_DESC_BY_LEVEL[trait][level]) ||
            "";

          return (
            <div key={trait} className="result-score-row">
              <div className="result-score-label">
                {/* 1줄: 코드 + (라벨) */}
                <div className="result-score-label-top">
                  <span className="result-score-code">{trait}</span>
                  <span className="result-score-name">
                    {TRAIT_LABEL[trait] || ""}
                  </span>
                </div>

                {/* 2줄: 점수 + 점수 구간에 맞는 설명 */}
                <div className="result-score-desc-row">
                  <span className="result-score-value">{value}</span>
                  {desc && <span className="result-score-desc">{desc}</span>}
                </div>
              </div>

              <div className="result-score-bar">
                <div
                  className="result-score-bar-fill"
                  style={{ width: `${value}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="result-radar-card">
        <p className="result-body-text">
          여덟 가지 성향을 한 번에 찍어본 레이더야. 어디가 유난히 튀어나와
          있는지 한눈에 구경해 봐.
        </p>
        <ScoresRadar scores={data} />
      </div>
    </section>
  );
}

export default ScoreTable;
